import HttpRequest from '@/libs/http'
const http = new HttpRequest()
export function getDeviceStatistics (data) {
    return http.request({
        url: '/api/admin/report_form/device',
        method: 'POST',
        data: data
    })
}


export function getPersonnelStatistics (data) {

    return http.request({
        url: '/api/admin/report_form/personnel',
        method: 'POST',
        data: data
    })
}

export function getDailyCheckStatistics (data) {

    return http.request({
        url: '/api/admin/report_form/daily_check_report_product',
        method: 'get',
        params: data
    })
}

export function getPlanMaintainStatistics (data) {

    return http.request({
        url: '/api/admin/report_form/plan',
        method: 'POST',
        data: data
    })
}

export function getCostStatistics (params) {

    return http.request({
        url: '/api/admin/report_form/cost',
        method: 'GET',
        params: params
    })
}


export function exportCostStatistics (params) {

    return http.request({
        url: '/api/admin/report_form/cost_export',
        method: 'GET',
        params: params
    })
}

export function getOEEListStatistics (data) {

    return http.request({
        url: '/api/admin/report_form/oee_list',
        method: 'POST',
        data: data
    })
}

export function getOEEStatistics (data) {

    return http.request({
        url: '/api/admin/report_form/oee',
        method: 'POST',
        data: data
    })
}

export function getPersonnelCost (params) {

    return http.request({
        url: '/api/admin/personnel_cost/list',
        method: 'GET',
        params: params
    })
}

export function editPersonnelCost (data) {

    return http.request({
        url: '/api/admin/personnel_cost/edit',
        method: 'POST',
        data: data
    })
}

export function delPersonnelCost (costId) {

    let param = {
        costId: costId
    }

    return http.request({
        url: '/api/admin/personnel_cost/del',
        method: 'GET',
        params: param
    })
}
